import { Injectable } from '@angular/core'
import { contract } from '@ftr/annotations-contracts'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClient } from './types'

/**
 * Create a client service for ftr-annotations for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactory extends AnnotationsApiClientFactoryBase {
  build(region: Region): AnnotationsApiClient {
    return this.buildClient(region, contract, 'annotations-v1')
  }
}
